<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<mat-card>
					<mat-card-header>
						<mat-card-title
							><span
								[innerHtml]="'Self-reflection questions' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span
						></mat-card-title>
					</mat-card-header>

					<mat-card-content>
						<div
							class="layout-block vertical"
							[style.align-items]="'inherit'"
							[style.gap]="'0.25em'"
						>
							<ng-container
								*ngFor="let question of screen.questions; let questionIndex = index; trackBy: trackByAutomatic"
							>
								<ng-container *lowgileScope="question; as: 'question'; let $scope">
									<ng-container
										*lowgileScope="questionIndex; as: 'questionIndex'; let $scope"
									>
										<mat-card>
											<mat-card-header>
												<mat-card-title
													><span
														[innerHtml]="question.question | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span
												></mat-card-title>
											</mat-card-header>

											<mat-card-content>
												<div
													class="layout-block"
													[style.align-items]="'inherit'"
													[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
													[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
													[style.--layout-column-count]="screen.columnVisibility.showManagerReview ? 2 : 1"
													[style.gap]="'0.5em 1em'"
												>
													<span
														[style.grid-column]="'span ' + (1)"
														[innerHtml]="'Self review*' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
													<ng-container
														*ngIf="screen.columnVisibility.showManagerReview"
														><span
															[style.grid-column]="'span ' + (1)"
															[innerHtml]="'Manager comment' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span
													></ng-container>

													<div
														class="layout-block vertical"
														[style.grid-column]="'span ' + (1)"
														[style.align-items]="'inherit'"
														[style.gap]="'1em'"
													>
														<ng-container
															*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(screen.viewMode.isManager || (screen.viewMode.isEmployee && !screen.gs.status.isSelfReviewPending))) as $disabled"
														>
															<ng-container
																*ngIf="$disabled; else else45"
																><span
																	style="
																		border: 1px solid lightgray;
																		padding: 0 0.5em;
																	"
																	[innerHtml]="question.sra.selfRating || '<p>&nbsp;</p>' | escapeHtml: 'safe' | replaceNewlines: 'span'"
																></span
															></ng-container>
															<ng-template #else45>
																@let $fc_48_1 =
																getFormControl(question.sra,
																'selfRating', 48, $scope,
																$formDirective, $disabled,
																$ignoreValidations);
																<div>
																	<lowgile-rich-text-editor
																		[formControl]="$fc_48_1"
																	/>
																	<div
																		style="
																			color: var(
																				--mat-form-field-error-text-color
																			);
																		"
																	>
																		@if($fc_48_1.dirty ||
																		$fc_48_1.touched) {
																		@for(error of
																		$fc_48_1.errors ?? {} |
																		keyvalue; track error.key) {
																		<mat-error
																			*ngIf="typeof error.value == 'string'"
																			[innerHtml]="error.value | escapeHtml: 'safe'"
																		/>
																		} }
																	</div>
																</div>
															</ng-template>
														</ng-container>
													</div>
													<ng-container
														*ngIf="screen.columnVisibility.showManagerReview"
														><div
															class="layout-block vertical"
															[style.grid-column]="'span ' + (1)"
															[style.align-items]="'inherit'"
															[style.gap]="'1em'"
														>
															<ng-container
																*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(screen.viewMode.isEmployee || (screen.viewMode.isManager && !screen.gs.status.isSelfReviewDone))) as $disabled"
															>
																<ng-container
																	*ngIf="$disabled; else else53"
																	><span
																		style="
																			border: 1px solid
																				lightgray;
																			padding: 0 0.5em;
																		"
																		[innerHtml]="question.sra.managerRating || '<p>&nbsp;</p>' | escapeHtml: 'safe' | replaceNewlines: 'span'"
																	></span
																></ng-container>
																<ng-template #else53>
																	@let $fc_56_1 =
																	getFormControl(question.sra,
																	'managerRating', 56, $scope,
																	$formDirective, $disabled,
																	$ignoreValidations);
																	<div>
																		<lowgile-rich-text-editor
																			[formControl]="$fc_56_1"
																		/>
																		<div
																			style="
																				color: var(
																					--mat-form-field-error-text-color
																				);
																			"
																		></div>
																	</div>
																</ng-template>
															</ng-container></div
													></ng-container>
												</div>
											</mat-card-content>
										</mat-card>
									</ng-container>
								</ng-container>
							</ng-container>
						</div>
					</mat-card-content>
				</mat-card>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
